import React, { useEffect, useState } from 'react';
import {
    Breadcrumb,
    Layout,
    Spin,
    Row,
    Col,
    Input,
    Button,
    Card,
    Upload,
    message,
    Image
} from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import Headerdiv from "../../layout/header";
import Footerdiv from "../../layout/footer";
import { APPBACKGROUND_COLOR, MAINAPIURL } from '../../appsettings';
import { Link, useParams } from "react-router-dom";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import { AlertError, AlertSuccess } from '../../usableclasses';

const { Content } = Layout;

const ProductAttribute = () => {
    const { id } = useParams();
    const UPDATED_BY = localStorage.getItem("USERID");
    const [isLoading, setIsLoading] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [product, setProduct] = useState(null)
    const [webLink, setWebLink] = useState(null)
    const [shortDesc, setShortDesc] = useState(null)
    const [mainImage, setMainImage] = useState(null);
    const [previewImage, setPreviewImage] = useState(null);
    const [file, setFile] = useState(null);

    useEffect(() => {
        if (id) {
            getProductDetails()
        }
    }, [id])

    useEffect(() => {
        if (product?.proSku) {
            getAttributes()
            getMainImage()
        }
    }, [product])

    const getProductDetails = async () => {
        try {
            setIsLoading(true)
            const headers = { SystemAccessToken: localStorage.getItem("AUTHCODE") }
            const response = await axios.get(`${MAINAPIURL}/products/getdetailbyid/${id}`, { headers })
            setProduct(response.data);
            return response.data;
        } catch (error) {
            console.error("Error fetching product details:", error);
            AlertError("Error fetching product details");
            return null;
        } finally {
            setIsLoading(false)
        }
    }

    const getAttributes = async () => {
        try {
            setIsLoading(true);
            const headers = { SystemAccessToken: localStorage.getItem("AUTHCODE") };
            const response = await axios.get(`${MAINAPIURL}/products/product/getmlmattributes/${id}`, { headers }); // Use product ID here
            const data = response.data;

            data.map((dt) => {
                if (dt.attributeType === "WEBLINK") {
                    setWebLink(dt);
                } else if (dt.attributeType === "SHORTDESC") {
                    setShortDesc(dt)
                }
            })
        } catch (error) {
            console.error("Error fetching attributes:", error);
            AlertError("Error fetching attributes");
        } finally {
            setIsLoading(false)
        }
    }

    const getMainImage = async () => {
        try {
            setIsLoading(true);
            const headers = {
                SystemAccessToken: localStorage.getItem("AUTHCODE"),
            };
            const response = await axios.get(`${MAINAPIURL}/products/product/getmlmmainimage/${product?.proSku}`, {
                headers
            });
            if (response.data && typeof response.data === 'string') {
                // Append a timestamp as a query parameter to bust the cache
                setMainImage(`${response.data}?_=${new Date().getTime()}`);
            } else {
                setMainImage(response.data); // Handle cases where response.data might not be a URL string
            }
        } catch (error) {
            console.error("Error fetching main image:", error);
            setMainImage(null);
            // AlertError("Error fetching main image"); // Consider if this alert is too noisy if an image is optional or not yet set.
        } finally {
            setIsLoading(false);
        }
    };


    const updateAttributes = async (type, content) => {
        if (!product?.proSku) {
            return
        }
        try {
            setIsLoading(true);
            const headers = {
                SystemAccessToken: localStorage.getItem("AUTHCODE"),
                'Content-Type': 'application/json',
            };

            const data = {
                productId: id,
                attributeType: type,
                attributeContent: content,
                updatedBy: UPDATED_BY,
            };

            await axios.post(`${MAINAPIURL}/products/product/updatemlmattribute`, data, { headers });
            AlertSuccess("Attribute updated successfully!");
            getAttributes();
        } catch (error) {
            console.error("Error updating attribute:", error);
            AlertError("Error updating attribute");
        } finally {
            setIsLoading(false);
        }
    };
    const handleImageUpload = async () => {
        try {
            setIsLoading(true);
            const headers = {
                SystemAccessToken: localStorage.getItem("AUTHCODE"),
                'Content-Type': 'multipart/form-data',
            };
            const formData = new FormData();
            formData.append('ProductCode', product?.proSku);
            formData.append('UploadedBy', UPDATED_BY);
            formData.append('UploadFile', file);
            await axios.post(`${MAINAPIURL}/products/product/uploadmlmmainimage`, formData, { headers });
            setFile(null);
            setFileList([]);
            setPreviewImage(null);
            getMainImage()
            AlertSuccess("Main image uploaded successfully!");
        } catch (error) {
            console.error("Error uploading main image:", error);
            AlertError("Error uploading main image");
        } finally {
            setIsLoading(false)
        }
    }
    return (
        <Spin spinning={isLoading} tip="Processing...">
            <Layout style={{ backgroundColor: APPBACKGROUND_COLOR, minHeight: '100vh' }}>
                <Headerdiv />
                <Content style={{ padding: '10px 20px' }}>
                    <Breadcrumb style={{ margin: "16px 0" }}>
                        <Breadcrumb.Item>Master</Breadcrumb.Item>
                        <Breadcrumb.Item><Link to={"/master/productlist"}>Products</Link></Breadcrumb.Item>
                        <Breadcrumb.Item>Product Attributes</Breadcrumb.Item>
                        <Breadcrumb.Item>{id}</Breadcrumb.Item>
                    </Breadcrumb>

                    <Card title="Product Information" style={{ marginBottom: 20 }}>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} md={4}>
                                <label>Use As</label>
                                <Input value={product?.proUseAs} readOnly />
                            </Col>
                            <Col xs={24} md={4}>
                                <label>Code</label>
                                <Input value={product?.proSku} readOnly />
                            </Col>
                            <Col xs={24} md={8}>
                                <label>Product Name</label>
                                <Input value={product?.proName} readOnly />
                            </Col>
                            <Col xs={12} md={4}>
                                <label>Size</label>
                                <Input value={product?.proSize} readOnly />
                            </Col>
                            <Col xs={12} md={4}>
                                <label>UOM</label>
                                <Input value={product?.uomName} readOnly />
                            </Col>
                        </Row>
                    </Card>
                    {/* Main Image Upload */}
                    <Card title="Main Image" style={{ marginBottom: 20 }}>
                        <Row gutter={[16, 16]}>
                            <Col xs={24} md={4}>
                                <div style={{
                                    width: 200,
                                    height: 150,
                                    border: '1px solid #ccc',
                                    borderRadius: 8,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    {mainImage ? (
                                        <Image
                                            src={mainImage}
                                            alt="Main Image"
                                            style={{
                                                width: 200,
                                                height: 150,
                                                objectFit: 'fill',
                                                borderRadius: 8,
                                            }}
                                        />
                                    ) : (
                                        <span>No Image</span>
                                    )}
                                </div>
                            </Col>
                            <Col xs={24} md={20}>
                                <Row gutter={10}>
                                    <Col>
                                        <Upload
                                            accept="image/jpeg"
                                            beforeUpload={(file) => {
                                                const isJpg = file.type === 'image/jpeg';
                                                const isLt2Mb = file.size / 1024 / 1024 < 2;
                                                if (!isJpg) message.error("Only JPG files allowed");
                                                if (!isLt2Mb) message.error("Image must be < 2MB");
                                                return isJpg && isLt2Mb;
                                            }}
                                            onChange={({ fileList, file }) => {
                                                setFileList(fileList);
                                                setFile(file.originFileObj);
                                                if (file.originFileObj) {
                                                    const reader = new FileReader();
                                                    reader.onload = (e) => {
                                                        setPreviewImage(e.target.result);
                                                    };
                                                    reader.readAsDataURL(file.originFileObj);
                                                } else {
                                                    setPreviewImage(null);
                                                }
                                            }}
                                            fileList={fileList}
                                            showUploadList={false}
                                        >
                                            <Button icon={<UploadOutlined />}>Select Image</Button>
                                            {file?.name && <span style={{ marginLeft: 8 }}>{file.name}</span>}
                                        </Upload>
                                    </Col>
                                    <Col>
                                        <Button type="primary" onClick={handleImageUpload} disabled={!file || isLoading}>
                                            Upload Image
                                        </Button>
                                    </Col>
                                </Row>
                                <div style={{ marginTop: 8 }}>
                                    <small>* Only Jpeg, max size 300KB</small>
                                </div>
                            </Col>
                        </Row>
                    </Card>

                    {/* Product Web Link */}
                    <Card title="Product Web Link" style={{ marginBottom: 20 }}>
                        <Row gutter={[16, 16]}>
                            <Col flex="auto">
                                <Input placeholder="Enter web link" value={webLink?.attributeContent} onChange={(e) => setWebLink({ ...webLink, attributeContent: e.target.value })} />
                            </Col>
                            <Col >
                                <Button type="primary" onClick={() => updateAttributes("WEBLINK", webLink?.attributeContent)}>Update</Button>
                            </Col>
                        </Row>
                    </Card>

                    {/* Product Short Description */}
                    <Card title="Product Short Description">
                        <Row gutter={[16, 16]}>
                            <Col span={24}>
                                <ReactQuill
                                    value={shortDesc?.attributeContent || ''}
                                    onChange={(content) => setShortDesc({ ...shortDesc, attributeContent: content })}
                                    placeholder="Enter your description..."
                                />
                            </Col>
                            <Col >
                                <Button type="primary" style={{ marginTop: 12 }} onClick={() => updateAttributes("SHORTDESC", shortDesc?.attributeContent)}>Update</Button>
                            </Col>
                        </Row>
                    </Card>
                </Content>
                <Footerdiv />
            </Layout>
        </Spin>
    );
};

export default ProductAttribute;
